import { render } from "./JdmItem.vue?vue&type=template&id=62e58e0d"
import script from "./JdmItem.vue?vue&type=script&lang=js"
export * from "./JdmItem.vue?vue&type=script&lang=js"

import "./JdmItem.vue?vue&type=style&index=0&id=62e58e0d&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QBadge,QBtn});
